import setEnv from '@global/helpers/setEnv';
const NowIsLogin = setEnv.isLogin();
require('@global/vendors/jquery.sticky.custom');

function navGlobal() {
  function navSlider() {
    // 展開社群 & 搜尋
    const $el = $('.nav__slider');

    if ($el.length < 1) return;

    function open(target, navHeightOuter) {
      const $target = $(target);
      const $stickyWrapper = $('.header .sticky-wrapper'); // 這個東西會包住NAV
      const isSticky = $stickyWrapper.hasClass('is-sticky');
      const isToggleHeight = $target.data('toggle-height');

      $target.data('toggle', 1).stop().slideDown();

      if (!isSticky && !isToggleHeight) {
        $target.data('toggle-height', 1);
        $stickyWrapper.animate({
          height: '+=' + navHeightOuter,
        });
      }
    }

    function close(target, navHeightOuter, callback) {
      const $target = $(target);
      const $stickyWrapper = $('.header .sticky-wrapper');
      const isToggleHeight = $target.data('toggle-height');

      $target
        .data('toggle', 0)
        .stop()
        .slideUp(function () {
          if (callback && typeof callback === 'function') callback();
        });

      if (isToggleHeight) {
        $target.data('toggle-height', 0);
        $stickyWrapper.animate({
          height: '-=' + navHeightOuter,
        });
      }
    }

    function toggle(target, navHeightOuter) {
      const $target = $(target);
      const $siblings = $target.siblings('.nav__slider');
      const isOpen = $target.data('toggle');

      if (isOpen) {
        close(target, navHeightOuter);
      } else {
        if ($siblings.data('toggle')) {
          close($siblings.get(0), navHeightOuter, function () {
            open(target, navHeightOuter);
          });
        } else {
          open(target, navHeightOuter);
        }
      }
    }

    function init() {
      const navHeightOuter = $el.outerHeight(true);

      $el.data('toggle', 0);
      $el.data('toggle-height', 0);

      $('[data-nav-slider]').on('click', function (event) {
        // data-nav-slider就是CONNECT & SEARCH 兩個按鈕
        const $this = $(this);
        const target = $($this.data('nav-slider')).get(0);
        // 挖出該a的文字

        toggle(target, navHeightOuter);
        // 展開它

        event.preventDefault();
      });

      $('.nav__slider__close').on('click', function (event) {
        const $this = $(this);
        const target = $this.parents('.nav__slider').get(0);

        close(target, navHeightOuter);

        event.preventDefault();
      });
    }

    init();
  }

  navSlider();
}

function navDesktop() {
  // nav 顯示隱藏所有功能
  function navShowAll() {
    $('.nav__show_all').on('click', function (e) {
      $(this).toggleClass('open');
      $('.nav').toggleClass('show_all');
      e.preventDefault();
    });
  }

  // 使用sticky套件把header貼在頭頂
  function headerStyle() {
    var $header = $('.header');
    var $headerLogo = $('.header__logo');
    var $headerLogoH = $('.header__logo_h');
    var $memberbox = $('.member-box');
    const hasMarquee = $('.m22-event-marquee')[0];

    $header.sticky({
      topSpacing: hasMarquee ? -10 : -60,

      onSticky: function () {
        $headerLogo.fadeOut();
        $headerLogoH.fadeIn();
        $memberbox.addClass('fixed');
      },

      offSticky: function () {
        $headerLogo.fadeIn();
        $headerLogoH.fadeOut();
        $memberbox.removeClass('fixed');
      },
    });
  }

  navShowAll();

  if ($('.login_header').length === 0) {
    // 登入相關頁面以外
    headerStyle();
  }
}

function navMobile() {
  const headerFixedCss = 'js-headerShow';
  let listShow;

  const $html = $('html');
  const $allList = $('.allitem_list, .more_list, .member_list');

  function fixedHeader() {
    const $window = $(window);
    const headerHeight = 90;
    let p;
    let t;

    // 手機版header貼頂
    $window.scroll(function () {
      p = $(this).scrollTop();

      if (p >= t && listShow === 0) {
        $html.removeClass(headerFixedCss);
      } else if (p > headerHeight) {
        // 上滑且卷軸超過 header 高
        $html.addClass(headerFixedCss);
      }

      setTimeout(function () {
        listShow = $allList.filter(':visible').length;
        t = p;
      }, 0);
    });
  }

  function topLevel() {
    // 第一層開關
    const $wrap = $('.home-content, .home-instagram-wrap, .main');

    const categoryButton = '.nav__all > a';
    const memberButton = '.account > a';
    const memberButtonLoging = 'i.icon__mypage';
    const moreButton = '.more-box';
    const $allListButton = $(categoryButton).add($(memberButton)).add($(moreButton));

    const $CommunityBox = $('.contact-box');
    const $CommunityList = $('.contact-box ul');
    const $CommunityClose = $('.contact_close');

    let winScrollTop;

    //  社群以外的列表
    $allListButton.on('click', function (e, target) {
      e.preventDefault();

      $('.nav__all, .account, .more-box').removeClass('open');

      $CommunityBox.removeClass('open');
      $CommunityList.slideUp(); // 關閉社群列表
      $CommunityClose.fadeOut();
      $html.addClass(headerFixedCss); // 顯示 header
      // 判斷 target
      if ($(e.target).is(categoryButton)) {
        target = '.allitem_list';
      } else if ($(e.target).is(memberButton) || $(e.target).is(memberButtonLoging)) {
        target = '.member_list';
      } else if ($(e.target).is(moreButton)) {
        target = '.more_list';
      }

      // 如果所有列表都還沒開就記錄卷軸位置
      if ($allList.filter(':visible').length === 0) {
        winScrollTop = $(window).scrollTop();
      }

      // 如果自己沒開表示正要執行打開動作
      if ($(target).filter(':visible').length === 0) {
        $wrap.addClass('disappear'); // 避免重新 loading 造成畫面閃爍，使用css控制
        $(target).slideDown();
        $allList.not(target).slideUp(); // 除了自己以外的都hide吧
        $(window).scrollTop(0);

        if ($(e.target).is('a')) {
          $(e.target).parent().addClass('open');
        } else {
          $(e.target).addClass('open');
        }
      } else {
        // 自己已經開了
        $wrap.removeClass('disappear');
        $(target).hide();
        $(window).scrollTop(winScrollTop);
      }

      // category可能target為span，需阻止事件冒泡
      e.stopPropagation();
    });

    // 展開社群
    $CommunityBox.on('click tough', function () {
      if ($CommunityList.filter(':visible').length > 0) {
        $CommunityBox.removeClass('open');
        $CommunityList.slideUp();
        $CommunityClose.fadeOut();
      } else {
        $CommunityBox.addClass('open');
        $CommunityList.slideDown();
        $CommunityClose.fadeIn();
      }
    });

    // 關掉社群
    $CommunityClose.on('click tough', function () {
      $CommunityList.slideUp();
      $CommunityClose.fadeOut();
    });
  }

  function subLevel() {
    function resetAllList() {
      // 移除不要DER"全系列"
      const $AllListSub = $allList.children('li').children('ul');
      for (var i = 0; i <= $AllListSub.length; i++) {
        $AllListSub.eq(i).prev().addClass('hassub');
      }
    }

    function toggleSubLevel() {
      // 子層開關
      const $allListSubButton = $allList.find('a');
      $allListSubButton.on('click tough', function (e) {
        // 有子層才會跑
        if ($(this).next('ul').children('li').length > 0) {
          e.preventDefault();
          $(this).toggleClass('open').next('ul').slideToggle();
        }
      });
      $('.isOpen a').click();
    }

    resetAllList();
    toggleSubLevel();
  }

  function tabStatus() {
    // 登入按鈕顯示
    if (NowIsLogin) {
      $('li.login').remove();
    } else {
      $('li.account').remove();
    }
  }

  if ($('.header').length > 0) {
    fixedHeader();
    topLevel();
    subLevel();
    tabStatus();
  }
}

export default {
  navGlobal: navGlobal,
  navDesktop: navDesktop,
  navMobile: navMobile,
};
